import { EChartIndicator } from '@aqx-core/common/api/user-account-setting';

import { ITooltipOption } from '../types/indicator';

export const chartMainIndicators = [
  EChartIndicator.TI_BOLL,
  EChartIndicator.TI_EMA,
  EChartIndicator.TI_MA,
  EChartIndicator.TI_SAR,
  EChartIndicator.TI_WMA
];

export const chartSubIndicators = [
  EChartIndicator.TI_ATR,
  EChartIndicator.TI_CCI,
  EChartIndicator.TI_MACD,
  EChartIndicator.TI_RSI,
  EChartIndicator.TI_SD,
  EChartIndicator.TI_SO
];

export const chartMainAndSubIndicators = [...chartMainIndicators, ...chartSubIndicators];

export const mapChartIndicatorTitle: Record<EChartIndicator, string> = {
  [EChartIndicator.TI_MA]: 'MA',
  [EChartIndicator.TI_SAR]: 'SAR',
  [EChartIndicator.TI_BOLL]: 'BOLL',
  [EChartIndicator.TI_EMA]: 'EMA',
  [EChartIndicator.TI_WMA]: 'WMA',
  [EChartIndicator.TI_MACD]: 'MACD',
  [EChartIndicator.TI_CCI]: 'CCI',
  [EChartIndicator.TI_RSI]: 'RSI',
  [EChartIndicator.TI_SD]: 'SD',
  [EChartIndicator.TI_SO]: 'SO',
  [EChartIndicator.TI_ATR]: 'ATR',
  [EChartIndicator.TI_WEMA]: 'WEMA',
  [EChartIndicator.TI_FIBONACCI]: 'FIBONACCI',
  [EChartIndicator.TI_ICHIMOKU]: 'ICHIMOKU',
  [EChartIndicator.TI_ADX]: 'ADX',
  [EChartIndicator.TI_HEIKINASHI]: 'HEIKINASHI',
  [EChartIndicator.TI_STOCHASTIC]: 'STOCHASTIC',
  [EChartIndicator.TI_WILLIAMSR]: 'WILLIAMSR'
};

const CHART_INDICATOR_TOOLTIPS = {
  ATR: () => ['Average True Range'],
  BOLL: () => ['Bollinger Bandwidth'],
  CCI: () => ['Commodity Channel Index'],
  EMA: () => ['Moving Average Exponential'],
  MA: () => ['Moving Average'],
  MACD: () => ['Moving Average Convergence Divergence'],
  RSI: () => ['Relative Strength Index'],
  SAR: () => ['Parabolic SAR'],
  SD: () => ['Standard Deviation'],
  SO: () => ['Stochastic Oscillator'],
  WMA: () => ['Moving Average Weighted']
};

export const mainIndicatorToolTips: ITooltipOption[] = [
  {
    labels: CHART_INDICATOR_TOOLTIPS.MA,
    type: () => mapChartIndicatorTitle[EChartIndicator.TI_MA]
  },
  {
    labels: CHART_INDICATOR_TOOLTIPS.SAR,
    type: () => mapChartIndicatorTitle[EChartIndicator.TI_SAR]
  },
  {
    labels: CHART_INDICATOR_TOOLTIPS.BOLL,
    type: () => mapChartIndicatorTitle[EChartIndicator.TI_BOLL]
  },
  {
    labels: CHART_INDICATOR_TOOLTIPS.EMA,
    type: () => mapChartIndicatorTitle[EChartIndicator.TI_EMA]
  },
  {
    labels: CHART_INDICATOR_TOOLTIPS.WMA,
    type: () => mapChartIndicatorTitle[EChartIndicator.TI_WMA]
  }
];

export const subIndicatorToolTips: ITooltipOption[] = [
  {
    labels: CHART_INDICATOR_TOOLTIPS.ATR,
    type: () => mapChartIndicatorTitle[EChartIndicator.TI_ATR]
  },
  {
    labels: CHART_INDICATOR_TOOLTIPS.CCI,
    type: () => mapChartIndicatorTitle[EChartIndicator.TI_CCI]
  },
  {
    labels: CHART_INDICATOR_TOOLTIPS.MACD,
    type: () => mapChartIndicatorTitle[EChartIndicator.TI_MACD]
  },
  {
    labels: CHART_INDICATOR_TOOLTIPS.RSI,
    type: () => mapChartIndicatorTitle[EChartIndicator.TI_RSI]
  },
  {
    labels: CHART_INDICATOR_TOOLTIPS.SD,
    type: () => mapChartIndicatorTitle[EChartIndicator.TI_SD]
  },
  {
    labels: CHART_INDICATOR_TOOLTIPS.SO,
    type: () => mapChartIndicatorTitle[EChartIndicator.TI_SO]
  }
];
